import React, { useState, useEffect, useRef, useMemo } from 'react'
import PopUp from '../../Common/PopUp';
import { useSelector } from 'react-redux';
import { showToast } from '../../Common/Messages';
import Tooltip from '../../Common/Tooltip';

const PREVIEW_STORAGE_PREFIX = "editPreviewDocData:";
const PREVIEW_STORAGE_TTL = 60 * 60 * 1000;

export const EditProperty = (props) => {
    const LoginStates = useSelector(state => state.login);
    const [morePopUp, setMorePopUp] = useState(null);
    const [status, setStatus] = useState('');
    const [buttonList, setButtonList] = useState(null);
    const [openDocInfo, setOpenDocInfo] = useState(false);
    const [docInfo, setDocInfo] = useState(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const infoRef = useRef();

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, []);

    const path = useMemo(() => {
        if (props.current?.path == null) return [];

        const array = props.current.path.split('/');
        const currentPath = [];
        for (var item in array) {
            if (item > 0 && array[item] !== "") {
                currentPath.push(<i key={`icon-${item}`} className='icoKdc12 next'></i>)
                currentPath.push(<span key={`path-${item}`}>{array[item]}</span>)
            }
        }
        return currentPath;
    }, [props.current?.path]);

    useEffect(() => {
        if (openDocInfo) {
            getDocInfo();
        } else {
            setDocInfo(null);
        }
    }, [openDocInfo]);

    useEffect(() => {
        if (!props.docData) return;
        const isWork = props.docData.workStatus === "CheckOut" && props.docData.updateUserId !== LoginStates.userId;
        const isQA = props.docData.qAId && props.docData.qAStatus !== 3 && props.docData.qAStatus !== 4 ? true : false;
        const messageQA = getMessageQA(props.docData.qAStatus);

        if (props.ViewMode) {
            setStatus(isWork ? `${props.docData.updateUserName}님이 ${props.docData.updateDate}부터 작업중입니다.`
                    : isQA ? messageQA: '');
        } else {
            setStatus(`${props.docData.updateDate}부터 작업중입니다.`);
        }
        getButtonList(isWork, isQA);
    }, [props.ViewMode, props.docData]);

    const getMessageQA = (qaStatus) => {
        switch (qaStatus) {
            case 1:
                return "검수 요청중입니다.";
            case 2:
                return "검수 진행중입니다.";
            default:
                return "";
        }
    }
    
    const getButtonList = (isWork, isQA) => {
        const buttons = [];
        if (props.ViewMode) {
            if(!isWork && (!isQA || props.docData.qAStatus > 2)) {
                buttons.push(<button className="btn-secondary" onClick={e => StartEdit(e)}>편집 시작</button>);
                if(props.docData.qAStatus !== 3 && props.docData.qAStatus !== 4)
                    buttons.push(<button className="btn-primary" onClick={() => props.SubmitQA()}>검수 요청</button>);
            } else if (isQA) {
                if (props.docData.qAStatus === 1 && props.docData.updateUserId === LoginStates.userId)
                    buttons.push(<button className="btn-secondary" onClick={e => {if(window.confirm("검수 요청을 취소하시겠습니까?"))RequestQA(e, "CancelRequest")}}>검수 요청취소</button>)
            }
        } else {
            buttons.push(<button className="btn-secondary" onClick={e => CancleEditClick(e)} >편집 취소</button>)
            buttons.push(<button className="btn-secondary" onClick={e => Save(e)}>저장</button>)
            buttons.push(<button className="btn-primary" onClick={e => EndEdit(e)}>편집 완료</button>)
        }
        setButtonList(buttons);
    }

    const handleClickOutside = (event) => {
        if (infoRef.current && !infoRef.current.contains(event.target)) {
            setOpenDocInfo(false);
        }
    }

    const goDocHome = () => {
        if (props.checkIsChange("Cancle")) props.setCurrent(null);
    }

    const StartEdit = (e) => {
        e.preventDefault();
        if (props.docData.workStatus === "CheckOut") {
            showToast('warning', "다른 사람이 작업중인 문서입니다.");
            return;
        }
        props.onEditDocument("EditStart");
    }
    const Save = (e) => {
        e.preventDefault();
        if (props.docData.title === "") {
            showToast('warning', "제목을 입력해주세요.");
            return;
        }
        if (!props.docData.data.blocks || props.docData.data.blocks.length === 0) {
            showToast('warning', "내용을 입력해주세요.");
            return;
        }
        props.onEditDocument("Update");
    }
    const RequestQA = (e, workingTag) => {
        e.preventDefault();
        props.onQADocument(workingTag, null);
    }
    const EndEdit = (e) => {
        e.preventDefault();
        if (props.checkIsChange("End")) {
            let comment = "";
            const handleChange = (e) => {
                comment = e.target.value;

            }
            setMorePopUp(
                <div className="request">
                    <div className="request-modal">
                        <div className="request-top">
                            <h3 className='request-title'>편집 내용 입력</h3>
                            <button className="btn-close" onClick={() => setMorePopUp(null)}>
                                <i className="icoKdc32 close"></i>
                            </button>
                        </div>
                        <div className="request-cnts">
                            <div className="memo">
                                <div className="cate-top">
                                    <h4 className="cate-title">편집 내용</h4>
                                    <span className="require">*</span>
                                </div>
                                <input className="input-memo" type="text" id="name" name="comment" placeholder="편집 내용을 입력하세요.(10자 이상)" onChange={handleChange} />
                            </div>
                        </div>
                        <button className="btn-request" onClick={() => {
                            const chosungRegex = /[ㄱ-ㅎ]/;
                            if (comment.trim() === "") {
                                showToast("warning", "내용을 입력해주세요.")
                                return;
                            }
                            if (chosungRegex.test(comment)) {
                                showToast("warning", "내용에 초성은 입력할 수 없습니다.")
                                return;
                            }
                            if (comment.length < 10) {
                                showToast("warning", "10글자 이상 입력해주세요.")
                                return;
                            }
                            props.onEditDocument("EditEnd", comment);
                            setMorePopUp(null);
                        }}>완료</button>
                    </div>
                </div>
            )
        }
    }
    const CancleEditClick = (e) => {
        e.preventDefault();
        const CancleEdit = (e) => {
            props.onEditDocument("EditCancle");
            setMorePopUp(null);
        }
        setMorePopUp(
            <div className="msg-popup discard-changes">
                <div className="alert-box">
                    <p className="title">편집 취소</p>
                    <p className="single-msg">모든 변경사항이 사라지고,<br />마지막 편집완료 시점으로 데이터가 돌아갑니다.<br />취소하시겠습니까?</p>
                    <div className="alert-btn-wrap">
                        <button className="btn-secondary" onClick={e => setMorePopUp(null)}>취소</button>
                        <button className="btn-primary" onClick={e => CancleEdit(e)}>확인</button>
                    </div>
                </div>
            </div>
        );
    }

    const MoreButtonClick = (e) => {
        e.preventDefault();
        const list = [];
        if (props.ViewMode && props.docData.workStatus !== "CheckOut" && (!props.docData.qAId || props.docData.qAStatus > 2)) {
            list.push(<li><a onClick={e => CopyToDocumentClick(e)}>문서 복제</a></li>);
            list.push(<li className="delete-doc"><a onClick={e => DeleteClick(e)}>삭제</a></li>);
        } else if (!props.ViewMode) {
            list.push(<li><a onClick={e => CopyFromDocuments(e, 'menu')}>문서 가져오기</a></li>);
            list.push(<li><a onClick={e => CopyFromDocuments(e, 'template')}>템플릿 가져오기</a></li>);
        }
        if (list.length > 0) {
            setMorePopUp(
                <div className="layer-list manual-more-list" style={{
                    "left": "inherit",
                    "top": "104px",
                }}>
                    <div className="context-menu" style={{
                        "right": "0"
                    }}>
                        <ul>
                            {list.map(x => { return x })}
                        </ul>
                    </div>
                </div>
            );
        }
    }
    const CopyToDocumentClick = (e) => {
        e.preventDefault();
        if (window.confirm("문서를 복제하시겠습니까?"))
            props.CopyToDocument();
        setMorePopUp(null);
    }
    const CopyFromDocuments = (e, from) => {
        props.CopyFromDocument(from);
        setMorePopUp(null);
    }
    const DeleteClick = (e) => {
        e.preventDefault();
        setMorePopUp(
            <div className="msg-popup delete-doc">
                <div className="alert-box">
                    <p className="title">삭제</p>
                    <p className="single-msg">'{props.docData.title}' 문서를 정말 삭제하시겠습니까?</p>
                    {/* 사유 보류 */}
                    {/* <div className="input-wrap">
                        <label>삭제 사유(필수)</label>
                        <input type="text" />
                    </div> */}
                    <div className="alert-btn-wrap">
                        <button className="btn-secondary" onClick={e => setMorePopUp(null)}>취소</button>
                        <button className="btn-nega" onClick={e => Delete(e)}>삭제</button>
                    </div>
                </div>
            </div>
        );
    }
    const Delete = (e) => {
        setMorePopUp(null)
        if (props.current.item.children && props.current.item.children.length > 0) {
            showToast('warning', "하위 문서가 존재합니다.");
            return;
        }
        props.onEditDocument("Delete");
    }
    const OpenRules = () => {
        const option = 'width=1000, height=600, left=400, top=100, scrollbars=yes, resizable=yes'
        window.open('/EditCenter/Rules', '_blank', option);
    }
    const OpenPopUp = (path, isData = false) => {
        const option = 'width=1200, height=800, left=400, top=100, scrollbars=yes, resizable=yes'
        let previewPath = path;

        if (isData) {
            if (!props.docData || !props.docBoxPath || !props.current?.item?.docId) {
                showToast('warning', "미리보기할 문서 정보가 없습니다.");
                return;
            }

            clearExpiredPreviewData();

            const previewId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            const previewData = {
                editorData: JSON.parse(JSON.stringify(props.docData)),
                docBoxPath: props.docBoxPath,
                docId: props.current.item.docId,
                createdAt: Date.now()
            };

            sessionStorage.setItem(`${PREVIEW_STORAGE_PREFIX}${previewId}`, JSON.stringify(previewData));
            previewPath = `${path}?previewId=${encodeURIComponent(previewId)}`;
        }

        window.open(previewPath, '_blank', option);
    }

    const clearExpiredPreviewData = () => {
        const now = Date.now();
        Object.keys(sessionStorage)
            .filter(key => key.startsWith(PREVIEW_STORAGE_PREFIX))
            .forEach(key => {
                try {
                    const item = JSON.parse(sessionStorage.getItem(key));
                    if (!item?.createdAt || now - item.createdAt > PREVIEW_STORAGE_TTL) {
                        sessionStorage.removeItem(key);
                    }
                } catch {
                    sessionStorage.removeItem(key);
                }
            });
    }
    const EditButtons = () => {
        return (
            <div className="btn-wrap" >
                <button className="btn-rule" onClick={e => OpenRules()} ><p>문서작성규칙</p></button>
                <Tooltip content="미리보기">
                    <button className="btn-icon" onClick={e => OpenPopUp('/EditCenter/Preview', true)}><i className='icoKdc24 magnifier-g'></i></button>
                </Tooltip>
                <Tooltip content="관련정보">
                    <button className="btn-icon" onClick={e => props.setOpen('info')} ><i className='icoKdc24 info'></i></button>
                </Tooltip>
                <Tooltip content="피드백">
                    <button className="btn-icon" onClick={e => props.setOpen('feedback')}><i className='icoKdc24 comment'></i></button>
                </Tooltip>
                <Tooltip content="히스토리">
                    <button className="btn-icon" onClick={e => props.setOpen('history')}><i className='icoKdc24 history'></i></button>
                </Tooltip>
                {props.isEditable && buttonList}
                {checkIsMore() && props.isEditable &&
                    <Tooltip content="더보기">
                        <button className="icoKdc32 kebab btn-kebab" onClick={e => MoreButtonClick(e)}></button>
                    </Tooltip>
                }
            </div>
        );
    }

    const checkIsMore = () => {
        if (!props.docData) return false;
        if (!props.ViewMode && (!props.docData.qAId || (props.docData.qAStatus === 0 || props.docData.qAStatus > 2))) {
            return true;
        }
        else if (props.ViewMode && props.docData.workStatus !== "CheckOut" && (!props.docData.qAId || (props.docData.qAStatus === 0 || props.docData.qAStatus > 2))) {
            return true;
        }
        return false;
    }

    const toggleDocInfo = (e) => {
        const infoWrapper = document.querySelector(".docinfo");
        const treeWrapper = document.querySelector(".left-ctgr");
        const header = document.querySelector(".gnb");

        const { x, y } = infoWrapper.getBoundingClientRect();
        const left = x - treeWrapper.clientWidth;
        const top = y - header.clientHeight;
        setPosition({ x: left, y: top });
        setOpenDocInfo(prev => !prev);
    };

    const getDocInfo = async () => {
        if (!props.current) return;
        // const body = {
        //     DocId: props.current.item.docId
        // };
        const response = await fetch('api/Edit/DocumentInfo?docId=' + props.current.item.docId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            // body: JSON.stringify(body)
        });
        if (response.status === 200) {
            const result = await response.json();
            setDocInfo(result.data?.table || []);
        }
    }

    const viewDocInfo = () => {
        const infoType = [
            { title: '게시경로', type: 'path' },
            { title: '제품', type: 'product' },
            { title: '버전', type: 'versionInfo' },
            { title: '작성자', type: 'updateUserName' }
        ];
        return docInfo && (
            <div className='doc-info-tooltip' style={{ left: position.x + 'px' }} onClick={e => e.stopPropagation()}>
                <ul className='doc-info-list-wrap'>
                    {docInfo.length === 0 ?
                        <li>게시 정보가 없습니다.</li>
                        :
                        <>
                            {infoType.map((type, index) => {
                                return (
                                    <li className='doc-info-list'>
                                        <p className='doc-info-list-title'>{type.title}</p>
                                        <div className='doc-info-list-cnts'>
                                            {docInfo.map(info => {
                                                const path = JSON.parse(info.path) || [];
                                                return (
                                                    type.type === "path" ?
                                                        <div className='path'>
                                                            {path.map((x, index) => {
                                                                return (
                                                                    <React.Fragment>
                                                                        <span className='path-li'>{x}</span>
                                                                        {index < path.length - 1 && <i className="icoKdc12 next"></i>}
                                                                    </React.Fragment>
                                                                )
                                                            })}
                                                        </div>
                                                        :
                                                        <p>{info[type.type]}</p>
                                                )
                                            })}
                                        </div>
                                    </li>
                                )
                            })}
                        </>
                    }
                </ul>
            </div>
        )
    }

    const menuInfo = () => {
        const path = (fullPath) => {
            const menuPath = [];
            for (var item in fullPath) {
                if (item > 0) {
                    menuPath.push(<i className='icoKdc12 next'></i>)
                }
                menuPath.push(<span>{fullPath[item]}</span>)
            }
            return menuPath;
        }
        return props.docData?.menuInfo?.length > 0 && (
            <div className='posted-doc'>
                <div className='badge-posted'>
                    <i className='icoKdc20 posted'></i>
                    <p>게시된 문서</p>
                </div>
                <p>게시경로</p>
                <div className='posted-link-wrap'>
                    {props.docData.menuInfo.map(menu => {
                        return (
                            <div className='posted-link' onClick={() => window.open(`/${menu.menuPath}/${menu.manualID}`, "_blank")}>
                                {path(menu.fullPath)}
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    return (
        props.current ?
            <div className="property">
                <header className='editor-header'>
                    <div className="docinfo-wrap">
                        <div className='path-wrap'>
                            <i className='icoKdc24 folder' onClick={goDocHome} style={{ cursor: "pointer" }}></i>
                            <div className="path">
                                <span onClick={goDocHome}>{props.menuName}</span>
                                {path}
                            </div>
                        </div>
                        <div className='divide'></div>
                        <div className='docinfo' ref={infoRef} onClick={toggleDocInfo}>
                            <i className='icoKdc24 docinfo'></i>
                            <span>문서정보</span>
                            <button className='docinfo-dropdown'><i className='icoKdc16 dropdown'></i></button>
                            {openDocInfo &&
                                viewDocInfo()
                            }
                        </div>
                    </div>
                    {EditButtons()}
                    <PopUp content={morePopUp} setContent={setMorePopUp} />
                </header>
                {menuInfo()}
                {status && <span className="txt-status">{status}</span>}
            </div>
            : null
    );
}

export const Intro = (props) => {
    useEffect(() => {
        fetch('datas/document/menu.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        }).then((response) => response.json())
            .then(data => {
                props.setMenuData(data);
            });
    }, []);
    const setNavMenu = () => {
        const data = props.menuData.filter(n => n.type.toLowerCase() === "document");
        return (
            <ul className="select-ctgr">
                {data.map((op, index) => <li key={index}>
                    <button className="item" onClick={(e) => selectCategory(op.menuName, op.path)}>
                        <div className="icon-wrap"><i className={op.icon}></i></div>
                        <h4 className="title">{op.menuName}</h4>
                        <p className="description" dangerouslySetInnerHTML={{ __html: op.description }}></p>
                    </button>
                </li>
                )}
            </ul>
        );
    }
    const selectCategory = (name, path) => {
        if (props.isPopUp && !props.checkIsCancle()) {
            return;
        }
        props.setMenuName(path);
        props.setCurrentCategory(name);
    };
    return (
        <>
            {
                props.visible &&
                <div className={`introWrap ${props.isPopUp}`}>
                    <div className="intro">
                        <p className="txt">매뉴얼 카테고리를 선택 해 주세요</p>
                        {setNavMenu()}
                        <div className="my-doc">
                            <a href={() => { }}>
                                <div className="user-pf">Y</div>
                                내 문서함
                            </a>
                        </div>
                        <p className="txt">또는</p>
                        <button className="btn-primary-t2 btn-new-doc"
                            onClick={(e) => selectCategory(e, "MyDocEdit", "")}
                        >내 문서함에서 새 문서 만들기</button>
                    </div>
                </div >
            }
        </>
    );
}

export const ListHeader = (props) => {
    const addSubClick = () => {
        let node = { depth: 0, item: props.data[0] };
        props.addSubClick(node);
    }
    return (
        <header>
            <div className="tree-top">
                {/* <button className='toggle' onClick={props.toggleListClick}><i className={`icoKdc24 ${props.isListOpen ? "collapse-24" : "expand-24"}`}></i></button> */}
                <p className="title">{props.currentCategory}</p>
                {/* <button className="btn-ctgr" onClick={e => {alert("보류")}}><i className="icoKdc16 expand"></i></button> */}
            </div>
            {props.isEditable &&
                <button className="btn-add" onClick={e => addSubClick()}><i className="icoKdc20 add"></i></button>
            }
        </header>
    );
}
